import { useEffect, useRef } from 'react'
import useAccessControl from '../hooks/useAccessControl'

/**
 * Uygulama açılışında access-control (yetki + mail) yükler.
 * Mail yönlendirme login olmadan da form gönderiminde lazım.
 */
const AccessControlBootstrap = () => {
  const { loadAccessControl } = useAccessControl()
  const started = useRef(false)

  useEffect(() => {
    if (started.current) return
    started.current = true
    loadAccessControl()
  }, [loadAccessControl])

  return null
}

export default AccessControlBootstrap
